import { Location } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, take } from 'rxjs';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { UserDataService } from 'src/app/shared/services/user-data.service';
import { DietPlanData } from './diet-plan.data';
import * as moment from 'moment';
import {
  DialogProperty,
  InputType,
  elementsConfig,
  inputConfig,
} from 'src/app/shared/components/common-dialog/Model/dialog-poperty';
import { DropdownConfig } from 'src/app/shared/components/common-dialog/configs';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogComponent } from 'src/app/shared/components/common-dialog/common-dialog.component';
import { DialogRef } from '@angular/cdk/dialog';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { Store } from '@ngrx/store';
import { selectAllClients, selectClientsLoading } from './store/diet.selectors';
import { loadClientProfiles } from './store/diet.actions';
import { AppointmentComponent } from '../appointment/appointment.component';

@Component({
  selector: 'app-create-diet-plan',
  templateUrl: './create-diet-plan.component.html',
  styleUrls: ['./create-diet-plan.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class CreateDietPlanComponent implements OnInit, OnDestroy {
  personalInfo: FormGroup = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    address: ['', Validators.required],
    email: ['@gmail.com', [Validators.required, Validators.email]],
    Country: ['UK', Validators.required],
    city: ['London', Validators.required],
    phoneNumber: [null, [Validators.required, Validators.maxLength(10)]],
    dob: ['', Validators.required],
    gender: ['', Validators.required],
    maritalStatus: ['', Validators.required],
    occupation: ['', Validators.required],
  });
  submitIcon = '../../../assets/images/submit (5).png';
  personal = '../../../assets/images/user (1).png';
  backIcon = '../../../assets/images/arrow-left.png';
  createPlan = false;
  headers = DietPlanData.HEADERS;
  userUID: string | undefined;
  bmi: number | undefined;
  displayedColumns: string[] = [
    'edit',
    'appointment',
    'firstName',
    'email',
    'phoneNumber',
    'status',
    'dietPlan',
    'package',
    'packageAmnt',
    'packageStartDate',
    'packageEndDate',
    'amntReceived',
    'amntReceivedDate',
    'amntRemaining',
    'amntRemainingDate',
  ];
  tableData: any[] = [];
  dataSource = new MatTableDataSource<any>(this.tableData);
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.dataSource.paginator = mp;
  }
  @ViewChild(MatAccordion) accordion: MatAccordion = new MatAccordion();
  panelOpenState = true;
  rowData: any;
  private subs!: Subscription;
  isLoading = false;
  pdfContent: any;
  readonly dialog = inject(MatDialog);
  appointmentDetails: any = { userUID: '', appointDetails: [] };
  allAppointments: any[] = [];
  clients$ = this.store.select(selectAllClients);
  loading$ = this.store.select(selectClientsLoading);
  constructor(
    private fb: FormBuilder,
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private userDataService: UserDataService,
    private pdfGenerator: PdfGeneratorService,
    private router: Router,
    private location: Location,
    private store: Store
  ) {
    // this.userUID = this.userDataService.userUID;
    this.userUID = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    if (this.userUID) {
      this.pdfGenerator.getData(this.userUID).then((data: any) => {
        this.pdfContent = data;
      });
    }
    // this.getClientProfile();
    this.store.dispatch(loadClientProfiles({}));
    console.log(this.clients$);
    this.clients$?.subscribe((data) => {
      this.dataSource.data = [...data]; // sorted or unsorted
    });
    // this.getAllAppointments();
  }

  onRefresh(): void {
    // this.store.dispatch(setClientsLoading({ loading: true }));
    this.store.dispatch(loadClientProfiles({ forceRefresh: true })); // optional payload
  }

  rowClicked(row: any) {
    if (row.status === 'New') return;

    if (row.status === 'Expired') {
      this.pdfGenerator.viewPdf(this.pdfContent);
      // this.router.navigate(['./layout//view-diet-plan/' + row.userUID]);
    } else if (row.status === 'Active') {
      this.router.navigate(['./layout/edit-diet-plan/' + row.userUID]);
      this.userUID = row.userUID;
      this.rowData = row;
      this.createPlan = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 50);
    } else if (row.status === 'Not Started') {
      this.userUID = row.userUID;
      this.rowData = row;
      this.createPlan = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 50);
    }
  }

  getAllAppointments() {
    this.firestore
      .collection('appointmentDetails')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.allAppointments.push(obj);
        });
      });
  }

  getClientProfile() {
    this.isLoading = true;
    this.subs = this.firestore
      .collection('clientProfile')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        this.tableData = [];
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          obj.firstName = obj.firstName + ' ' + obj.lastName;
          obj['userUID'] = e.payload.doc.id;
          this.transformDate(obj);
          this.tableData.push(obj);
          if (
            obj['userUID'] === this.userUID &&
            !this.location.path(true).includes('view-diet-plan')
          ) {
            this.rowClicked(obj);
          }
        });
        // this.dataSource.data = this.tableData;
        this.dataSource.data = this.tableData.sort(
          (objA, objB) =>
            Number(new Date(objB.packageStartDate)) -
            Number(new Date(objA.packageStartDate))
        );
        this.isLoading = false;
      });
  }

  transformDate(data: any) {
    data.amntReceivedDate = moment(
      data.amntReceivedDate
        ? data.amntReceivedDate.toDate()
        : data.amntReceivedDate
    ).format('DD/MM/YYYY');
    data.amntRemainingDate = moment(
      data.amntRemainingDate
        ? data.amntRemainingDate.toDate()
        : data.amntRemainingDate
    ).format('DD/MM/YYYY');
    data.packageStartDate = moment(
      data.packageStartDate
        ? data.packageStartDate.toDate()
        : data.packageStartDate
    ).format('DD/MM/YYYY');
    data.packageEndDate = moment(
      data.packageEndDate ? data.packageEndDate.toDate() : data.packageEndDate
    ).format('DD/MM/YYYY');
  }

  getLabel(status: string): string | undefined {
    if (status === 'New') return 'Queastionnaire Not Filled';
    else if (status === 'Not Started') return 'Create';
    else if (status === 'Active') return 'Edit';
    else if (status === 'Expired') return 'View';
    else return;
  }

  getAptLabel(row: any): string | undefined {
    if (row.appointmentNo === 0 || row.appointmentNo === undefined)
      return 'Schedule Appointment';
    else if (row.appointmentNo === 1 && this.getAptStatus(row) !== 'Completed')
      return 'Appointment Scheduled';
    else if (row.appointmentNo === 1 && this.getAptStatus(row) === 'Completed')
      return `Schedule Follow-Up ${row.appointmentNo}`;
    else if (row.appointmentNo === 2)
      return `Follow-Up ${row.appointmentNo - 1} Scheduled`;
    else return;
  }

  back() {
    this.router.navigate(['./layout/create-diet-plan']);
    this.createPlan = false;
  }

  onEdit(row: any) {
    this.router.navigate(['./layout/create-client-profile/' + row.userUID]);
  }

  scheduleAppoint(row: any, isAptScheduled: any) {
    let prop = isAptScheduled
      ? DietPlanData.rescheduleApt(row, this.fetchAptData())
      : DietPlanData.scheduleNewApt(row);
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: prop,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let appotDetails = {
          clientName: row.firstName,
          userUID: row.userUID,
          appotNo: isAptScheduled ? row.appointmentNo : row.appointmentNo + 1,
          appotDate: prop?.inputConfig && prop.inputConfig[2].inputText,
          appotTime: prop?.inputConfig && prop.inputConfig[3].inputText,
          duration: row.appointmentNo + 1 > 1 ? '20 Minutes' : '45 Minutes',
          appotStatus: 'Scheduled',
        };
        if (isAptScheduled) {
          this.appointmentDetails.appointDetails[this.getAptIndex()] =
            appotDetails;
          this.appointmentDetails.userUID = row.userUID;
        } else {
          this.appointmentDetails.appointDetails.push(appotDetails);
          this.updateAppointNo(row);
        }
        this.createAppointment(row.userUID);
      }
    });
  }

  scheduleNewApt(row: any) {
    const dialogRef = this.dialog.open(AppointmentComponent, {
      // width: '800px',
      // height: '100%',
      data: row,
    });
    console.log(dialogRef);
  }

  getAptIndex() {
    return this.appointmentDetails.appointDetails.findIndex(
      (x: any) => x.appotStatus === 'Scheduled'
    );
  }

  fetchAptData() {
    return this.appointmentDetails.appointDetails.filter(
      (x: any) => x.appotStatus === 'Scheduled'
    )[0];
  }

  updateAppointNo(row: any) {
    const document = this.firestore
      .collection('clientProfile')
      .doc(row.userUID);
    const data = document
      .update({ appointmentNo: row.appointmentNo + 1 })
      .then(() => {
        console.log('Client status updated successfully');
      });
  }

  getAptDetails(row: any) {
    this.appointmentDetails = this.allAppointments?.filter(
      (x) => x.userUID === row.userUID
    )[0];
    // this.scheduleAppoint(row, this.checkAptVal());
  }

  getAptStatus(row: any) {
    if (this.allAppointments) {
      const apt = this.allAppointments?.filter(
        (x) => x.userUID === row.userUID
      )[0];
      return apt?.appointDetails?.find(
        (x: any) => x?.appotStatus === 'Completed'
      )?.appotStatus;
    }
  }

  checkAptVal() {
    if (this.appointmentDetails?.appointDetails?.length > 0) {
      return this.appointmentDetails.appointDetails.some(
        (x: any) => x.appotStatus === 'Scheduled'
      );
    } else return false;
  }

  createAppointment(userUID: string) {
    this.firestore
      .collection('appointmentDetails')
      .doc(userUID)
      .set(this.appointmentDetails)
      .then((data) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: 'Appointment Schedule successfully.',
            type: 'success',
          },
        });
        this.isLoading = false;
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        this.isLoading = false;
      });
  }

  applyFilter(filterValue: any) {
    const str = filterValue.target.value;
    this.dataSource.filter = str.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnDestroy(): void {
    this.subs?.unsubscribe();
  }
}
